export * from './language';
export * from './error';
export * from './paths';
export * from './request-data';

export const
  HTTP_HEADER_CONTENT_TYPE = 'Content-Type',
  HTTP_HEADER_AUTHORIZATION = 'Authorization',
  MIME_TYPE_JSON = 'application/json',
  HTTP_HEADER_CONSOLIDATOR_CODE = "Consolidator-Code",
  HTTP_HEADER_MODULE_CODE = "Module-Code",
  HTTP_HEADER_ACCESS_CONTROL_REQUEST_HEADERS = "Access-Control-Request-Headers",
  HTTP_HEADER_ACCESS_CONTROL_ALLOW_HEADERS = "Access-Control-Allow-Headers",
  HTTP_TOKEN = "Token",

  PATTERN_LETTERS= '^[a-zA-Z]*$',
  PATTERN_LETTERS_WITH_SPACE = '^[a-zA-Z ]*$',
  PATTERN_LETTERS_WITH_SPACE_HYPHEN = '^[a-zA-Z- ]*$',
  PATTERN_LETTERS_WITH_SPACE_PERIOD = '^[a-zA-Z. ]*$',
  PATTERN_ALPHA_NUMERIC_SPACE_ONLY = '.*\\S.*[a-zA-z0-9 ]',
  PATTERN_ALPHA_NUMERIC_NO_SPACE = '^\\s*[a-zA-Z0-9]*\\s*$',
  PATTERN_ALPHA_NUMERIC_WITH_SPACE = '^[a-zA-Z0-9 ]*$',
  PATTERN_ALPHA_NUMERIC_WITH_SPACE_HYPHEN = '^[a-zA-Z0-9- ]*$',
  PATTERN_ALPHA_NUMERIC_WITH_SPC_CHAR = '^[a-zA-Z0-9-_. ]*$',
  PATTERN_ALPHA_NUMERIC_WITH_CHAR = '^[a-zA-Z0-9-_.]*$',
  PATTERN_NUMERIC = '^[0-9-]*$',
  PATTERN_NUMERIC_WITH_SIGN = '^-*[0-9]+$',
  PATTERN_NUMERIC_WITH_SPACE = '^[0-9 _ ,+]*$',
  PATTERN_DECIMAL = '^-*[0-9]*(\.[0-9]{0,2})?$',
  PATTERN_DECIMAL_WITH_SIGN = '^-*[0-9]*(\.[0-9]{0,2})?$',
  PATTERN_NUMERIC_NEGATIVE = '^-[0-9]*$',
  PATTERN_EMAIL = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$', 
  PATTERN_NO_SPACE = '^([^ ])*$',
  PATTERN_WEEK = '^([1-9]|[1234][0-9]|5[0-2])-([0-9]{4})$',
  PATTERN_WEEK_NUMBER = '^([1-9]|[1234][0-9]|5[0-2])-([0-9]{1,})$',
  PATTERN_WEEK_FORMAT = '^(.{1,2})-(.{4})$',
  PATTERN_V5_CUSTOMER_CODE = '^[V]([0-9]{9})',
  PATTERN_RESTRICTED_FILENAME_CHARS = '^[^/\\\\:\*"<>|]*$',
  PATTERN_DATE = '/(([0-2]?\d{1})|([3][0,1]{1}))/^[0,1]?\d{1}/(([1]{1}[9]{1}[9]{1}\d{1})|([2-9]{1}\d{3}))$/',

	DATETIME_FORMAT_FILE_PREFIX_S3 = "YYYYMMDDHHmmssSSS"
;